import React, { useContext, useState } from 'react';

import _ from 'lodash';
import { useAssignmentsNamesList } from 'sdk';

import { SearchField } from 'pages/Teachers/shared';
import { AssignmentDialogModes } from 'pages/Teachers/shared/AssignmentDialog';
import { colors } from 'theme/palette';
import { MuiAutocompleteChangeReasons } from 'utils/constants';
import { useMixpanelPageOpenTrack } from 'utils/integrations/mixpanel';

import AddButton from 'components/AddButton';
import AssignmentCreateDialogContext from 'components/AssignmentCreateDialogContext';
import CurriculumNode from 'components/CurriculumNode';
import Typography from 'components/Typography';

import styles from './styles.module.scss';

const TeacherAssignmentCreate = () => {
  const [selectedAssignment, setSelectedAssignment] = useState(null);

  const { data: assignmentsNames } = useAssignmentsNamesList({
    data: { include_prior_years: true }
  });

  useMixpanelPageOpenTrack('Teacher opened Create page');

  const { open: openCreateAssignmentDialog } = useContext(
    AssignmentCreateDialogContext
  );

  const handleAssignmentChange = (event, value, reason) => {
    if (_.isNil(value)) {
      return;
    }

    setSelectedAssignment(value);

    if (reason === MuiAutocompleteChangeReasons.SELECT_OPTION) {
      openCreateAssignmentDialog({
        mode: AssignmentDialogModes.COPY,
        selectedAssignment: value
      });
    } else {
      openCreateAssignmentDialog({
        mode: AssignmentDialogModes.CREATE,
        selectedAssignment: value
      });
    }
  };

  return (
    <div className={styles.content}>
      <div className={styles.addButtonWrapper}>
        <AddButton onClick={openCreateAssignmentDialog} color="pink">
          Create a new assignment
        </AddButton>
      </div>

      <div className={styles.inputWrapper}>
        <Typography variant="H-TEXT-2" color={colors.blue1} align="center">
          Copy an assignment
        </Typography>
        <Typography
          variant="B-Text-2"
          color={colors.grey1}
          align="center"
          className={styles.helpText}
        >
          Modify a copy of an assignment you’ve already made.
        </Typography>

        <SearchField
          value={selectedAssignment}
          options={assignmentsNames || []}
          getOptionLabel={(assignment) => assignment.name}
          onChange={handleAssignmentChange}
          noOptionsText="No Assignments"
          placeholder="Search your assignments"
        />
      </div>

      <div className={styles.inputWrapper}>
        <Typography variant="H-TEXT-2" color={colors.blue1} align="center">
          use a template
        </Typography>
        <Typography
          align="center"
          variant="B-Text-2"
          color={colors.grey1}
          className={styles.helpText}
        >
          Using a set curriculum? Implement it here.
        </Typography>
      </div>
      <CurriculumNode />
    </div>
  );
};

export default TeacherAssignmentCreate;
